import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
  Canceler
} from "axios";

import { Toast } from "vant";
// 错误信息提示框
const MESSAGE_DURATION = 5 * 1000;
// 超时时间
const TIME_OUT = 30 * 1000;

interface IHttpStatus {
  [prop: number]: string;
}
const strategies: IHttpStatus = {
  400: "请求错误",
  401: "授权信息过期，请重新登录",
  403: "拒绝访问",
  404: "页面未找到",
  405: "请求方式错误",
  408: "请求超时",
  500: "服务器错误",
  501: "服务未实现",
  502: "网络错误",
  503: "服务不可用",
  504: "网络超时",
  505: "版本不受支持"
};
const strateCtx = (status: number): string =>
  (strategies[status] || `连接出错:${status}`) + "，请检查网络或联系管理员！";

// 防止弹出多个过期提示
const isExpired = false;

/**
 * 错误提示 方法
 *
 * @param {String} tip 提示信息
 */
const MessageTip = (tip: string) => {
  Toast({
    message: tip || "服务异常",
    duration: MESSAGE_DURATION
  });
};

const instance: AxiosInstance = axios.create({
  withCredentials: false,
  timeout: TIME_OUT
});

instance.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    config.headers["Authorization"] =
      "Token ZXlKcmFXUWlPaUl3SWl3aWRIbHdJam9pU2xkVUlpd2lZV3huSWpvaVNGTXlOVFlpZlEuZXlKcFlYUWlPakUxTmpJMU5UVTFOVGNzSW5OMVlpSTZJbXh2WjJsdUlpd2lhWE56SWpvaWQyVmtjeUlzSW5CaGJHY2lPaUpoWlhNdE1qVTJMV05pWXlJc0luQnJaWGxwWkNJNklqRWlMQ0pxZEdraU9pSXRNbmRsWWkxaGNHbHNiMmRwYmlJc0ltRjFaQ0k2SW5kbFlpMWhjR2tpTENKd1pHRjBZU0k2SWpnek1qSTJZakEwTWprd05EazJOREF3WkdGak4yWXlOV1E1Tm1Fek1tTTBZbVZoWmprNFpEY3hORE0zWkRZeE9URmhOVEZsWW1JNU1HRTVaR0UzTkdZeU0yWmxNalUzWldVMU1UaGpZV0k1WkRkbE5XTXpZall6T0dNeVkyVTJNQ0o5LnNRWTFHSm5JbXR4T2RnOEZFeU04N0ZyQldHZEZFb0R5cElNSWV3eUd4VEE=";
    return config;
  },
  (err: AxiosError): Promise<AxiosError> => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (response: AxiosResponse) => {
    const { data, status } = response;
    if (status < 200 || status >= 300) {
      MessageTip(strateCtx(status));
      return Promise.reject(new Error("HTTP 响应状态码异常"));
    } else {
      const { code, msg } = data;
      if (+code !== 0 && +code !== 600) {
        MessageTip(msg);
        return data;
      } else {
        return data;
      }
    }
  },
  async (err: AxiosError): Promise<AxiosError> => {
    if (!axios.isCancel(err)) {
      const { response } = err;
      if (response) {
        const { status } = response;
        !isExpired && MessageTip(strateCtx(status));
        // 401 退出登录，重新跳转到登录页
        // if (status === 401 && !isExpired) {
        //   isExpired = true
        //   await store.dispatch('user/logOut', {}, { root: true })
        //   router.replace(
        //     {
        //       path: '/login',
        //       query: {
        //         redirect: router.currentRoute.fullPath
        //       }
        //     },
        //     () => (isExpired = false)
        //   )
        // }
      } else {
        // 断网，超时
        if (err.message.includes("timeout")) {
          MessageTip("请求超时，请检查网络是否连接正常");
        } else {
          // 可以展示断网组件
          MessageTip("请求失败，请检查网络是否已连接");
        }
      }
    }
    return Promise.reject(err);
  }
);

export default instance;
